import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const vehicleAssetSchema = z.object({
  deviceId: z.string(),
  isActive: z.boolean(),
  modifiedOn: coercedDate,
});

export type VehicleAsset = z.infer<typeof vehicleAssetSchema>;
